<template>
  <v-skeleton-loader v-if="loading" type="article" />
  <v-row v-else>
    <v-col :cols="12" :md="6" :lg="4" v-for="(period, index) in [1, 7, 14]" :key="index">
      <v-card-title class="tw-p-0 tw-py-2 tw-sticky tw-bg-white">{{summaryGrid[index].title }}</v-card-title>
      <section v-for="(record, index) in formattedSummaryData(period)" :key="index">
        <v-subheader class="tw-pl-0">{{ record.label }}</v-subheader>
        <v-sheet class="tw-bg-gray-100">
          <c-data-list :value="record.values" class="tw-bg-transparent tw-pt-2 tw-pb-2" />
        </v-sheet>
      </section>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'TheTabRecentSummaryGrid',
  async mounted () {
    this.loading = true
    let dataSet = await this.$api.station.get('', {
      id: this.$route.params.id,
      summary: true
    })
    dataSet = this._.groupBy(dataSet, 'TimeInterval')
    for (const key in dataSet) {
      this.summaryData[key] = {}
      dataSet[key].forEach(item => {
        this.summaryData[key][item.ParameterName] = item.ParameterValue
      })
    }
    this.loading = false
  },
  data () {
    return {
      loading: true,
      summaryGrid: [
        {
          title: 'Past 24 hours',
          class: 'tw-bg-gray-100'
        },
        {
          title: 'Past 7 days',
          class: 'tw-bg-gray-100'
        },
        {
          title: 'Past 14 days',
          class: 'tw-bg-gray-100'
        }
      ],
      summaryData: []
    }
  },
  methods: {
    formattedSummaryData (period) {
      return [
        {
          label: 'Air Temperature (°F)',
          values: [
            { label: 'Avg. Temperature', value: this.summaryData[period].AirTC_Avg },
            { label: 'Min Temperature', value: this.summaryData[period].AirTC_Min },
            { label: 'Max Temperature', value: this.summaryData[period].AirTC_Max }
          ]
        },
        {
          label: 'Humidity (%)',
          values: [
            { label: 'Avg. Humidity', value: this._.round(this.summaryData[period].RH, 2) },
            { label: 'Min Humidity', value: this._.round(this.summaryData[period].RH_Min, 2) },
            { label: 'Max Humidity', value: this._.round(this.summaryData[period].RH_Max, 2) }
          ]
        },
        {
          label: 'Wind Speed (MPH)',
          values: [
            { label: 'Avg. Wind Speed', value: this.summaryData[period].WS_ms_Avg },
            { label: 'Max Wind Speed', value: this.summaryData[period].WS_ms_Max }
          ]
        },
        {
          label: 'Soil Temperature (°F)',
          values: [
            { label: 'Avg. Soil Temp_4in', value: this.summaryData[period].TSoil_4in_Avg }
          ]
        },
        {
          label: 'Precipitation (mm)',
          values: [
            { label: 'Total Precipitaion', value: this._.round(this.summaryData[period].Rain_mm_Tot, 2) }
          ]
        },
        {
          label: 'Soil Moisture (m³/m³)',
          values: [
            { label: 'Avg. Soil Mois_4in', value: this._.round(this.summaryData[period].VWC_4in_Avg, 2) }
          ]
        },
        {
          label: 'Potential Evapotranspiration (mm)',
          values: [
            { label: 'Avg PET', value: this._.round(this.summaryData[period].PET, 2) }
          ]
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
